import { useCallback } from "react"

import { Flex } from "antd"
import { useNavigate } from "react-router-dom"

import { useSwitchBusinessAccount } from "../../Containers/User/hooks/useSwitchBusinessAccount"
import Icon from "../../Icon"
import { openHideLink } from "../../Utils/utils"

import "./styles.less"

export const BannerDemoModeFixed = ({ externalDemoMode, isLightMode }) => {
  const navigate = useNavigate()

  const { hasBAOnboardingInProgress, goToIncompleteBAOnboarding } = useSwitchBusinessAccount()

  const topUp = useCallback(() => {
    if (externalDemoMode) {
      openHideLink("https://app.chargeback.io/sign-up", "_blank")
    } else {
      if (isLightMode) {
        navigate("/settings/balance?open_add_funds=true")
        return
      }
      if (hasBAOnboardingInProgress) {
        goToIncompleteBAOnboarding()
      } else {
        navigate("/getting_started")
      }
    }
  }, [
    externalDemoMode,
    hasBAOnboardingInProgress,
    goToIncompleteBAOnboarding,
    isLightMode,
    navigate
  ])

  const bannerText = externalDemoMode
    ? "You're exploring Chargeback in Demo Mode. Ready to protect your real business?"
    : isLightMode
      ? "You're in Demo Mode. Add funds to activate chargeback alerts."
      : "You're in Demo Mode. Complete the steps of your Business Account creation."

  const btnText = externalDemoMode ? "Register now" : isLightMode ? "Add funds" : "Getting started"

  return (
    <Flex className="demo-mode-banner" gap={8} align="center" justify="center">
      <Icon className="triangle-error-icon" type={"alert_triangle_error"} />
      <p className="text">
        <>{bannerText} </>
        <a onClick={topUp} className="text strong">
          {btnText}
        </a>{" "}
        →
      </p>
    </Flex>
  )
}

export default BannerDemoModeFixed
